import ListingsCountersTypes from '../action-types/listingsCounters';

const initialState = {
  loading: true,
  error: null,
  data: [
    {
      id: 'my_assignments',
      label: 'My Assignments',
      available: null,
    },
    {
      id: 'get_listings',
      label: 'Get Listing',
      available: null,
      items: [
        {
          id: 'photos',
          label: 'Photos',
          available: null,
        },
        {
          id: 'videos',
          label: 'Videos',
          available: null,
        },
        {
          id: 'edits',
          label: 'Edits',
          available: null,
        },
        {
          id: 'new_listings',
          label: 'New Listings',
          available: null,
        },
      ],
    },
    {
      id: 'pending_breeder',
      label: 'Pending Breeder',
      available: null,
    },
    {
      id: 'listings_available',
      label: 'Available',
      available: null,
    },
    {
      id: 'listings_unavailable',
      label: 'Unavailable',
      available: null,
    },
  ],
};

const ListingsCountersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ListingsCountersTypes.FETCH_LISTINGS_COUNTERS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case ListingsCountersTypes.FETCH_LISTINGS_COUNTERS_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        data,
        loading: false,
      };
    }
    case ListingsCountersTypes.FETCH_LISTINGS_COUNTERS_ERROR: {
      const { error } = action;
      return {
        ...state,
        error,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default ListingsCountersReducer;
